import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { longTestimonials, shortTestimonials } from '../data/testimonials';
import { stats } from '../data/copy';
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-168" data-mp="3grj6donkftrg">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-169" data-mp="3bq3kjudkdj80" />)}
    </div>;
}
export function StatsAndProof() {
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-170" data-mp="3lpuenuy7pw7k">
        <div className="mx-auto max-w-3xl" data-id="element-171" data-mp="3lo03378tzgg5">
          <h2 className="text-center font-display text-xl font-bold tracking-[.12em] text-brand-light sm:text-2xl" data-id="element-172" data-mp="3asaf4zm02cl">
            📊 MADRES YA ORDENADAS
          </h2>
          <div className="mt-10 grid grid-cols-2 gap-x-5 gap-y-10" data-id="element-173" data-mp="d9rkms00w61p">
            {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-174" data-mp="8b6i2lxataa3">
                <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-175" data-mp="8crdsevcmz9j">{value}</p>
                <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-176" data-mp="1ge65uwe0ajt4">
                  {label}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-177" data-mp="1q9hfj0ak50u0">
        <div className="mx-auto max-w-6xl" data-id="element-178" data-mp="1ucw4whkdytk4">
          <h2 className="mb-10 text-center font-display text-2xl font-bold sm:text-3xl" data-id="element-179" data-mp="1udysafii2dva">
            💬 LO QUE DICEN LAS MADRES
          </h2>
          <div className="grid gap-5 md:grid-cols-3" data-id="element-180" data-mp="24aa8vhp4hpvj">
            {shortTestimonials.map((item, index) => <motion.article key={item.name} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05,
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-181" data-mp="291s7w07l5gdv" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-182" data-mp="mzv5dla3ccfc">
                  <div className="grid h-11 w-11 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-183" data-mp="ixqe2t747rvv">
                    {item.initials}
                  </div>
                  <div data-id="element-184" data-mp="ryeufujze4bx">
                    <h3 className="font-bold" data-id="element-185" data-mp="rxwrkf2tcrv1">{item.name}</h3>
                    <p className="text-sm text-slate-400" data-id="element-186" data-mp="16n171oi84hzg">{item.place}</p>
                  </div>
                </div>
                <div className="mt-5" data-id="element-187" data-mp="11ohjxkrw905i">
                  <Stars data-id="element-188" data-mp="11ng8hf6yubn9" />
                </div>
                <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-189" data-mp="1fnh8ksfepf1o">“{item.quote}”</p>
              </motion.article>)}
          </div>
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-190" data-mp="3heat7u494mgj">
      <div className="mx-auto max-w-5xl" data-id="element-191" data-mp="3cg9dnj61b59t">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-192" data-mp="3chkd56sg5qv4">
          💬 LO QUE DICEN LAS MADRES
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-193" data-mp="1wws6tfo3b06p">
          {longTestimonials.map(item => <article key={item.name} className="border-l-2 border-brand-green pl-4" data-id="element-194" data-mp="1j5n3a2hlpnr3">
              <Stars data-id="element-195" data-mp="1j3kc3f4ppoks" />
              <p className="mt-2 font-bold" data-id="element-196" data-mp="1n7094ckp1qy0">
                {item.name} <span className="font-normal text-slate-400" data-id="element-197" data-mp="1n5ffcp67ec17">· {item.place}</span>
              </p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-198" data-mp="1965ydna6bdw6">{item.quote}</p>
            </article>)}
        </div>
      </div>
    </section>;
}